// Only the configured Gather origin is used for generated iframe URLs.
export function gatherAudienceUrl(room, origin) {
    if (!room || !room.PublicCode) return null;
    try {
        const base = new URL(origin || 'https://gather.tractusevents.com');
        if (base.protocol !== 'https:' && !(base.protocol === 'http:' && ['localhost', '127.0.0.1', '[::1]'].includes(base.hostname))) return null;
        return new URL('/s/' + encodeURIComponent(room.PublicCode) + '?embed=1', base.origin).href;
    } catch (_) { return null; }
}

// The existing webinar player expands these placeholders in ordinary embeds.
// Keep identity in the fragment, which Gather consumes as correlation metadata.
// Never use this browser-supplied value as an authentication credential.
export function gatherWebinarAudienceUrl(room, origin, showCode, sessionCode) {
    const audienceUrl = gatherAudienceUrl(room, origin);
    if (!audienceUrl || !showCode || !sessionCode) return null;
    // Session/viewer/visit codes are substituted without URL encoding by the
    // legacy player. Session codes must be URL-safe; viewer/visit codes are its
    // existing 32-character generated IDs. Fail instead of truncating the join key.
    if (!/^[A-Za-z0-9_-]+$/.test(sessionCode)) return null;
    // Escape only the delimiter and escape marker within the stored show field.
    // Ordinary show codes stay readable; a colon or percent sign stays unambiguous.
    const showField = String(showCode).replace(/%/g, '%25').replace(/:/g, '%3A');
    const correlation = ['tw1', showField, String(sessionCode), '0'.repeat(32), '0'.repeat(32)];
    if (correlation.join(':').length > 256) return null;
    // URL-encode the static field, preserving only the intended runtime slots.
    // Gather decodes the fragment once; reporting splits on ':' then decodes show.
    return audienceUrl + '#thirdPartyId=tw1:' + encodeURIComponent(showField)
        + ':{{SessionCode}}:{{UserCode}}:{{LoginInstanceCode}}';
}

export function hasGatherEmbed(items, audienceUrl) {
    if (!audienceUrl) return false;
    const target = new URL(audienceUrl);
    return (items || []).some(item => {
        if (!item) return false;
        const type = String(item.Type || '').toLowerCase();
        const sources = ['sidebarembed', 'iframeembed'].includes(type) && item.Value ? [item.Value] : [];
        if (type === 'section' || type === 'sidebarembed' && !item.Value) {
            const details = String(item.Details || '');
            for (const match of details.matchAll(/<iframe\b[^>]*\bsrc\s*=\s*["']([^"']+)["']/gi)) sources.push(match[1]);
            for (const match of details.matchAll(/\[embed=([^\]\r\n]+)\]/g)) sources.push(match[1]);
        }
        return sources.some(source => {
            try {
                const candidate = new URL(source);
                return candidate.origin === target.origin && candidate.pathname.replace(/\/$/, '') === target.pathname;
            } catch (_) { return false; }
        });
    });
}
